// extracted by mini-css-extract-plugin
export default {"container":"SettingsImageEditor-module__container--NorR9","input":"SettingsImageEditor-module__input--iJ6zX"};